import { z } from 'zod';

import { DividendFrequency, DividendPayoutType } from '../../../hooks/dividend/dividend.types';

export const DIVIDEND_PER_SHARE_MAX_DECIMALS = 4;

export const formItemSchema = z.object({
  amountPerShare: z
    .number()
    .positive()
    .refine(
      (value) => (value.toString().split('.')[1]?.length ?? 0) <= DIVIDEND_PER_SHARE_MAX_DECIMALS,
      `Maximum ${DIVIDEND_PER_SHARE_MAX_DECIMALS} decimal places`,
    )
    .optional(),
  shareClassId: z.string().uuid().optional(),
  shareClassName: z.string().optional(),
  stakeholderId: z.string().uuid().optional(),
  stakeholderName: z.string().optional(),
  totalAmount: z.number().positive().optional(),
});

export const stakeholderDocSchema = z.object({
  filesLinks: z.array(z.string()),
  fullName: z.string(),
  stakeholderId: z.string().uuid(),
});

export const stepOneSchema = z.object({
  frequency: z.nativeEnum(DividendFrequency),
  name: z.string().trim().min(1, 'This field is required').max(50, 'Maximum 50 characters'),
  periodIndex: z.number().int().min(1).max(12).nullable(),
  type: z.nativeEnum(DividendPayoutType),
  year: z.number().int().min(2000).max(2100),
});

export const addDividendSchema = stepOneSchema.extend({
  additionalNotes: z.string().max(3000).optional(),
  filesLinks: z.array(z.string()),
  items: z.array(formItemSchema),
  stakeholderDocuments: z.array(stakeholderDocSchema),
});

export type AddDividendFormData = z.infer<typeof addDividendSchema>;
export type FormItem = z.infer<typeof formItemSchema>;
export type StakeholderDoc = z.infer<typeof stakeholderDocSchema>;
